(() => {
  const toggle = document.getElementById('navToggle');
  const nav = document.getElementById('siteNav');
  const submenuButtons = Array.from(document.querySelectorAll('.nav-item-toggle'));

  const closeSubmenus = (except = null) => {
    document.querySelectorAll('.nav-item--open').forEach((item) => {
      if (item === except) return;
      item.classList.remove('nav-item--open');
      const button = item.querySelector('.nav-item-toggle');
      if (button) {
        button.setAttribute('aria-expanded', 'false');
        const label = button.getAttribute('aria-label') || '';
        button.setAttribute('aria-label', label.replace(/^Fermer/, 'Ouvrir'));
      }
    });
  };

  const closeMobileNav = () => {
    if (!toggle || !nav) return;
    nav.classList.remove('open');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Ouvrir le menu');
    closeSubmenus();
  };

  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const isOpen = nav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', String(isOpen));
      toggle.setAttribute('aria-label', isOpen ? 'Fermer le menu' : 'Ouvrir le menu');
      if (!isOpen) closeSubmenus();
    });

    nav.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        if (window.matchMedia('(max-width: 1180px)').matches) closeMobileNav();
      });
    });
  }

  submenuButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const item = button.closest('.nav-item');
      if (!item) return;
      const willOpen = !item.classList.contains('nav-item--open');

      closeSubmenus(item);
      item.classList.toggle('nav-item--open', willOpen);
      button.setAttribute('aria-expanded', String(willOpen));

      const label = button.getAttribute('aria-label') || '';
      button.setAttribute(
        'aria-label',
        willOpen ? label.replace(/^Ouvrir/, 'Fermer') : label.replace(/^Fermer/, 'Ouvrir')
      );
    });
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('.nav-item')) closeSubmenus();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeSubmenus();
    closeMobileNav();
    toggle?.focus();
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth > 1180 && nav?.classList.contains('open')) closeMobileNav();
  });

  const qtyInputs = document.querySelectorAll('[data-qty-input]');
  document.querySelectorAll('[data-cart-wrist-select]').forEach((select) => {
    const property = select.form.querySelector('[data-cart-wrist-property]');
    const syncWrist = () => {
      property.value = (select.selectedOptions[0]?.dataset.wristSize || '').trim();
    };
    select.addEventListener('change', syncWrist);
    select.form.addEventListener('submit', syncWrist);
    syncWrist();
  });
  qtyInputs.forEach((input) => {
    input.addEventListener('change', () => {
      const minimum = Number(input.min || 1);
      if (!input.value || Number(input.value) < minimum) input.value = String(minimum);
    });
  });

  // Keep Shopify's native cart update and checkout flow, including line properties and discounts.
  const cartForm = document.getElementById('cart-form');
  if (cartForm) {
    let updateTimer;
    cartForm.querySelectorAll('[name="updates[]"]').forEach((input) => {
      input.addEventListener('change', () => {
        clearTimeout(updateTimer);
        updateTimer = setTimeout(() => {
          if (!cartForm.reportValidity()) return;
          const updateButton = document.querySelector('button[name="update"][form="cart-form"]');
          const status = cartForm.querySelector('[data-cart-update-status]');
          if (status) status.hidden = false;
          if (updateButton) cartForm.requestSubmit(updateButton);
        }, 450);
      });
    });
    cartForm.addEventListener('submit', () => clearTimeout(updateTimer));
  }

  const revealEls = document.querySelectorAll('.fade-in-up');
  if (revealEls.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });

    revealEls.forEach((el) => observer.observe(el));
  } else {
    revealEls.forEach((el) => el.classList.add('is-visible'));
  }
})();
